<template>
  <div>
    <h2 class="content-heading">
      <i class="si si-share mr-5"></i> Verkoopkanalen
    </h2>

    <job-list ref="jobList" />

    <div class="row">
      <div class="col-md-6 col-xl-3" v-for="channel in salesChannels" :key="channel.key">
        <sales-channel-widget :sales-channel="channel" @sync="loadJobList"></sales-channel-widget>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../utils/http'
import SalesChannelWidget from './SalesChannelWidget'
import JobList from '../jobs/JobList'

export default {
  components: { SalesChannelWidget, JobList },
  data () {
    return {
      salesChannels: []
    }
  },
  methods: {
    loadJobList () {
      this.$refs.jobList.load()
    }
  },
  created () {
    return http.get('/sales-channels')
      .then((response) => {
        this.salesChannels = response.data.data
      })
      .catch(() => {
        this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het ophalen van de verkoopkanalen. Probeer het opnieuw.', 'error')
      })
  }
}
</script>



// WEBPACK FOOTER //
// SalesChannelsPage.vue?e8ff8966